import "./kw-toc.js";
import "./kw-swiper.js";
import "./kw-bs.js";
import { tocOverlapTrigger } from "./lib/kw-overlap.js";
import { debounce } from "./kw-validation.js";

(() => {
  const overlapItems = document.querySelectorAll(".kw-overlap--item");
  overlapItems.forEach((item) => {
    const overlappStack = new Set();
    const debouncedOverlapTrigger = debounce(
      tocOverlapTrigger.bind(null, item, overlappStack),
      15,
    );
    window.addEventListener("scroll", debouncedOverlapTrigger);
  });
})();

(() => {
  const body = document.querySelector("body");

  function openDialog(dialog, dialogClass) {
    dialog.showModal();
    body.classList.add(`${dialogClass}-open`);
  }

  function dialogClickInit(dialog, dialogClass) {
    const closeDialog = () => {
      body.classList.remove(`${dialogClass}-open`);
      dialog.close();
    };
    dialog.onclose = (e) => {
      e.preventDefault();
      closeDialog();
    };
    dialog.onclick = (e) => {
      if (
        e.target.dataset?.action === "close" ||
        !e.target.closest(`.${dialogClass}--body`)
      ) {
        closeDialog();
      }
    };
  }

  function dialogInit() {
    const dialogClass = "kw-about-dialog-iframe";
    const dialog = document.getElementById(dialogClass);
    const iframe = dialog?.querySelector("img");
    if (!iframe) {
      console.log(`img not found`);
      return;
    }

    const docsList = document.querySelectorAll("img.kg-image");
    if (!docsList) {
      console.log("img.kg-image not found");
      return;
    }

    const articleContent = document.querySelector(
      "article .kw-article--wrapper",
    );
    if (!articleContent) {
      console.log("article .kw-article--wrapper not found");
      return;
    }

    articleContent.addEventListener("click", (e) => {
      const docsItem = e.target.closest("img.kg-image") || e.target.closest(".kg-gallery-image img");
      const url = docsItem?.src;
      if (!url) return;
      iframe.src = url;
      openDialog(dialog, dialogClass);
    });
    dialogClickInit(dialog, dialogClass);
  }
  dialogInit();
})();
(() => {
  const content = document.querySelector("article .kw-article--content");
  if (!content) {
    return;
  }
  const tableList = content.querySelectorAll("table");
  tableList.forEach((table) => {
    const wrapper = document.createElement("div");
    wrapper.setAttribute("class", "kw-article--table");
    window.requestAnimationFrame(() => {
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  });
})();
